import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const card: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const leftSide: SxStyle = {
  display: 'flex',
  padding: (p) => p.spacing(0.75, 1),
  borderRightWidth: '1px',
  borderRightStyle: 'solid',
  borderRightColor: (p) => p.palette.grey[300],
};
